import { FETCH_GROUPS, CLEAR, CHANGE_THRESHOLD, FETCH_QUARTILE_LOCATIONS } from './mutation-types'
import Vue from 'vue'
import json from '@/mock/scores.json'
import moment from 'moment'

export default {
  [FETCH_GROUPS] (state, groups) {
    state.groups = {}
    groups.forEach(group => {
      Vue.set(state.groups, group.id, group)
    })
  },

  [FETCH_QUARTILE_LOCATIONS] (state, locations) {
    state.locations = {}
    for (let i = 0; i < locations.length; ++i) {
      Vue.set(state.locations, i, locations[i])
    }
  },

  [CHANGE_THRESHOLD] (state, { recentThreshold, recentThresholdUnit, fullData }) {
    state.recentThreshold = recentThreshold
    state.recentThresholdUnit = recentThresholdUnit
    state.fullData = fullData

    // @todo actually connect to the API!
    const filtered = fullData
      ? json
      : json.filter(row => moment().add(-recentThreshold, recentThresholdUnit).diff(moment(row['created_at'])) < 0)

    state.groups = {}
    filtered.forEach(row => {
      if (!(row['assessment_location'] in state.groups)) {
        state.groups[row['assessment_location']] = {}
      }
      if (!(row['score_group_id'] in state.groups[row['assessment_location']])) {
        state.groups[row['assessment_location']][row['score_group_id']] = []
      }
      state.groups[row['assessment_location']][row['score_group_id']].push(row)
    })
  },

  [CLEAR] (state) {
    state.recentThreshold = 2
    state.recentThresholdUnit = 'week'
    state.fullData = false
    state.groups = {}
    state.locations = []
  }
}
